<template>
  <button-full
    @click.native="addToCart(product)"
    :disabled="isProductDisabled"
    data-testid="addToCart"
    class="btn btn-primary btn-buy"
  >
    <slot>{{ $t('Add to cart') }}</slot>
  </button-full>
</template>

<script>
import { formatProductMessages } from '@vue-storefront/core/filters/product-messages'
import { notifications } from '@vue-storefront/core/modules/cart/helpers'
import focusClean from 'theme/components/theme/directives/focusClean'
import ButtonFull from 'theme/components/theme/ButtonFull.vue'
import { mapGetters } from 'vuex'

export default {
  directives: { focusClean },
  components: { ButtonFull },
  props: {
    product: {
      required: true,
      type: Object
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    productCartLabel (product) {
      if (!product) {
        return ''
      }
      const name = typeof product.name === 'string' ? product.name.trim() : ''
      return name || (product.sku ? String(product.sku) : '')
    },
    onAfterRemovedVariant () {
      this.$forceUpdate()
    },
    afterSuppliesProductAddToCart (messages) {
      this.$store.dispatch('supplies/setCartMessages', messages)
    },
    async addToCart (product) {
      try {
        this.$bus.$emit('cart-add-item', product) // needed for gtm
        const result = await this.$store.dispatch('cart/addItem', { productToAdd: product })

        const messages = []
        if (result) {
          messages.push({
            type: 'success',
            message: this.$t('{productName} has been added to the cart!', {
              productName: this.productCartLabel(product)
            }),
            action1: { label: this.$t('OK') },
            action2: null
          })
        }

        if (product.is_supplies_active) {
          this.$store.dispatch('supplies/openSupplies', { product })
          this.afterSuppliesProductAddToCart(messages)
        } else if (result) {
          this.$store.dispatch('ui/openMicrocart')
        }
      } catch (message) {
        this.notifyUser(notifications.createNotification({ type: 'error', message }))
      }
    },
    notifyUser (notificationData) {
      this.$store.dispatch('notification/spawnNotification', notificationData, { root: true })
    }
  },
  computed: {
    ...mapGetters({
      isAddingToCart: 'cart/getIsAdding'
    }),
    isProductDisabled () {
      return this.disabled || formatProductMessages(this.product.errors) !== '' || this.isAddingToCart
    }
  },
  beforeMount () {
    this.$bus.$on('product-after-removevariant', this.onAfterRemovedVariant)
  },
  beforeDestroy () {
    this.$bus.$off('product-after-removevariant')
  }
}
</script>
